export default "__VITE_ASSET__B32IgJiv__"